(function () {
  // Injects video-player-ui's pip-persist-loader.js into <head> so a floating
  // (picture-in-picture) video player can persist across Academy navigations.
  // Loading it is unconditional — the feature's real opt-in / kill switch is the
  // `enablePictureInPicturePersistence` player prop.
  //
  // This is an inline copy of academy-common-lib's injectPipPersistLoader():
  // this early requester is raw-loaded (raw-loader!) and inlined in <head>, so
  // it can't ESM-import the shared util (nor `enviro`, which the shared util
  // uses for the QA check). Keep the two in sync.
  (function injectPipPersistLoader() {
    // Already present — nothing to do. Anchored to the loader's path prefix so
    // an unrelated script whose URL merely contains "pip-persist-loader" can't
    // be mistaken for it.
    if (
      document.querySelector(
        'script[src*="/video-player-ui/ex/pip-persist-loader"]'
      )
    ) {
      return;
    }

    // livePaths share one CDN domain across QA + prod; the QA build appends
    // `-qa` before the ext. Inline equivalent of `enviro.isQa()` (can't import
    // enviro here); anchored suffix match so only real *.hubspotqa.com hosts
    // resolve to the QA loader.
    var isQa = /\.hubspotqa\.com$/.test(window.location.hostname);
    var loaderPath = isQa
      ? '/video-player-ui/ex/pip-persist-loader-qa.js'
      : '/video-player-ui/ex/pip-persist-loader.js';

    // Use the bender-published static-domain prefix (resolves prod/qa/local)
    // rather than hard-coding it. The bender mixin renders before this early
    // requester in both index.html.js and hubless.html.js; fall back to the
    // public CDN domain if it isn't on the page yet.
    var bender = window.hubspot && window.hubspot.bender;
    var staticDomainPrefix =
      (bender && bender.staticDomainPrefix) || '//static.hsappstatic.net';

    var script = document.createElement('script');
    script.src = staticDomainPrefix + loaderPath;
    // LOCAL PIP TEST — when localStorage `VIDEO_PLAYER_ENV` is 'local', load the
    // locally-deployed video-player-ui build instead of the published CDN
    // livePath. Remove before committing.
    try {
      if (window.localStorage.getItem('VIDEO_PLAYER_ENV') === 'local') {
        script.src =
          'https://local.hsappstatic.net/video-player-ui/static/js/pip-persist-loader.js';
      }
    } catch (e) {}
    script.setAttribute('data-pip-loader-source', 'academy');
    document.head.appendChild(script);
  })();

  var supportsCache = 'caches' in window;
  var CACHE_NAME = 'hs-academy';
  const LANGUAGES = ['EN', 'ES', 'DE', 'JA', 'FR', 'PT'];

  function makeEarlyRequest(requestName, endpoint, options) {
    options = options || {};

    if (isIe11) {
      endpoint +=
        '?ie11cacheBust=' +
        Math.round(Math.random() * 9999999999999).toString();
    }

    var url = window.quickFetch.getApiUrl(endpoint, true);

    window.quickFetch.makeEarlyRequest(requestName, {
      url: url,
      dataType: 'json',
      contentType: 'application/json',
      type: options.method || 'GET',
      data: options.data,
      noPortalId: !!options.noPortalId,
    });
    if (supportsCache && options.useCacheStorage) {
      window.hubspot.academy = window.hubspot.academy || {};
      window.hubspot.academy.fromCacheStorage =
        window.hubspot.academy.fromCacheStorage || {};

      caches.open(CACHE_NAME).then(function (cache) {
        var earlyRequest = window.quickFetch.getRequestStateByName(requestName);
        if (earlyRequest) {
          earlyRequest.whenFinished(function (result) {
            var data = JSON.stringify(result);

            // Save the response in the cache
            cache.put(
              url,
              new Response(data, {
                status: 200,
                headers: new Headers({
                  'Content-Type': 'application/json;charset=utf-8',
                  'Content-Length': data.length,
                  Date: new Date().toUTCString(),
                }),
              })
            );
          });

          // Check if there's a previously saved response in the cache
          cache.match(url).then(function (cachedResponse) {
            if (cachedResponse && cachedResponse.ok) {
              cachedResponse.json().then(function (json) {
                window.hubspot.academy.fromCacheStorage[endpoint] = {
                  result: json,
                  timestamp: Date.parse(cachedResponse.headers.get('Date')),
                };
              });
            }
          });
        }
      });
    }
  }

  var isIe11 = false;
  try {
    isIe11 = window.navigator.userAgent.indexOf('Trident/7.0') > -1;
  } catch (e) {}

  var lang = 'en';
  var langParam = '';
  try {
    lang =
      JSON.parse(
        localStorage.getItem('i18n-cached-standard-locales') || '[]'
      )[0] || lang;
    lang = lang.split('-')[0];
    langParam = (location.search.split('language=')[1] || '').split('&')[0];
    if (!LANGUAGES.includes(lang.toUpperCase())) {
      lang = 'en';
    }
    if (!LANGUAGES.includes(langParam.toUpperCase())) {
      langParam = '';
    }
  } catch (error) {
    console.warn(error);
  }

  makeEarlyRequest(
    'cross-hublet-accounts',
    '/accounts/v1/accounts/cross-hublet',
    { noPortalId: true }
  );
  makeEarlyRequest('user-info', '/login-verify/user-info', {
    noPortalId: true,
  });

  const portalId = window.quickFetch.getPortalId();

  if (portalId) {
    makeEarlyRequest('api-verify', '/login-verify/hub-user-info');
    makeEarlyRequest('portal-scopes', `/hubs2/v1/scopes/hub/${portalId}`);

    window.quickFetch.afterAuth((authData) => {
      const toggleGlobalNav = () => {
        const isMobile = window.matchMedia('(max-width: 544px)').matches;

        const hideNavStyleElement =
          document.getElementById('hs-nav-hide-style');

        if (!hideNavStyleElement) {
          return;
        }

        if (isMobile) {
          hideNavStyleElement.disabled = false;
        } else {
          hideNavStyleElement.disabled = true;
        }
      };

      toggleGlobalNav();

      window.addEventListener('resize', toggleGlobalNav);
    });
  }
})();
